import { ITableColumn, TableColumnTypeEnum, WidthType } from 'src/app/models/tableColumns/tableColumn.interface';
import { AiFindingsThreadTableRowViewModel } from './ai-findings-thread-table-row-view-model';

export const aiFindingsThreadsTableColumns: ITableColumn[] = [
  {
    labelPath: 'aiFindingsThreadsPage.tableColumns.name',
    propertyKey: 'name',
    colType: TableColumnTypeEnum.TextWithIcon,
    iconSrc: 'platformIcon',
    iconAlt: 'platform',
    width: 300,
    widthType: WidthType.Pixel,
  },
  {
    labelPath: 'aiFindingsThreadsPage.tableColumns.actorName',
    propertyKey: 'avatarLabels' as keyof AiFindingsThreadTableRowViewModel,
    disabledProp: 'avatarLabelsDisabled',
    colType: TableColumnTypeEnum.Avatar,
    width: 100,
    widthType: WidthType.Pixel,
  },
  {
    labelPath: 'aiFindingsThreadsPage.tableColumns.agentName',
    propertyKey: 'agentNames',
    colType: TableColumnTypeEnum.Text,
    width: 126,
    widthType: WidthType.Pixel,
  },
  {
    labelPath: 'aiFindingsThreadsPage.tableColumns.findingsBySeverity',
    propertyKey: 'findingsBySeverity' as keyof AiFindingsThreadTableRowViewModel,
    colType: TableColumnTypeEnum.Severities,
    width: 130,
    widthType: WidthType.Pixel,
  },
  {
    labelPath: 'aiFindingsThreadsPage.tableColumns.lastFinding',
    propertyKey: 'lastFinding',
    colType: TableColumnTypeEnum.DateTime,
    dateFormat: 'MMM d, y, h:mm a',
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'lastFinding',
    isSortableDisabled: true,
  },
  {
    labelPath: 'aiFindingsThreadsPage.tableColumns.owasp',
    propertyKey: 'owasp',
    colType: TableColumnTypeEnum.Text,
    width: 230,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'aiFindingsThreadsPage.tableColumns.labels',
    propertyKey: 'labels' as keyof AiFindingsThreadTableRowViewModel,
    colType: TableColumnTypeEnum.Label,
    width: 146,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'aiFindingsThreadsPage.tableColumns.firstActivity',
    propertyKey: 'firstActivity',
    colType: TableColumnTypeEnum.DateTime,
    dateFormat: 'MMM d, y, h:mm a',
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'aiFindingsThreadsPage.tableColumns.lastActivity',
    propertyKey: 'lastActivity',
    colType: TableColumnTypeEnum.DateTime,
    dateFormat: 'MMM d, y, h:mm a',
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: false,
    withCopyIcon: true,
    iconOnly: true,
  },
  {
    labelPath: 'aiFindingsThreadsPage.tableColumns.threadId',
    propertyKey: 'id',
    colType: TableColumnTypeEnum.CopyableText,
    width: 80,
    widthType: WidthType.Pixel,
    withCopyIcon: true,
    iconOnly: true,
  },
  {
    labelPath: 'aiFindingsThreadsPage.tableColumns.owaspAsi',
    propertyKey: 'owaspAsi',
    colType: TableColumnTypeEnum.Text,
    width: 200,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
];
